const CONTENT_READ = /^(?:\/events\/[^/?]+|\/auto-content\/preview)(?:\?|$)/

function retryable(url, error) {
    if (!CONTENT_READ.test(url) || error?.response || error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') return false
    return ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)
}

function delay(signal) {
    return new Promise((resolve, reject) => {
        const cancel = () => {
            clearTimeout(timer)
            signal?.removeEventListener('abort', cancel)
            const error = new Error('CONTENT_READ_CANCELLED')
            error.code = 'ERR_CANCELED'
            reject(error)
        }
        const timer = setTimeout(() => {signal?.removeEventListener('abort', cancel);resolve()}, 400)
        signal?.addEventListener('abort', cancel, {once:true})
        if (signal?.aborted) cancel()
    })
}

async function recoverContentRead(request, url, {signal, canRetry = () => true, wait = delay} = {}) {
    try { return await request() }
    catch (error) {
        // Only these two public read contracts may be replayed. Never retry
        // account, checkout, submission, HTTP authorization or validation errors.
        if (!retryable(url, error) || signal?.aborted || !canRetry()) throw error
        await wait(signal)
        if (signal?.aborted || !canRetry()) throw error
        return request()
    }
}

module.exports = {recoverContentRead, retryable}
